var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.9227905,19.9512939c-12.3299561,0-19.0800171,6.0900269-23.0599976,10.9900513-2.9099731-5.0300293-9.6799927-10.9900513-20-10.9900513-11.5299683,0-17.75,6.0800171-20.4099731,9.9300537v-8.210022h-19.8900146c1.3800049,3.4099731,2.0999756,7.2600098,2.0999756,11.4199829,0,15.1799927-10.1599731,25.7600098-17.5799561,35.1600342l-9.7300415,12.2299805h30.6900024v12.9799805h15.6100464v-37.4899902c0-10.8599854,7.289978-15.7600098,12.4499512-15.7600098,5.1700439,0,9.4100342,3.7000122,9.4100342,10.6000366v42.6499634h22.3800049v-39.5999756c0-9.2800293,5.5599976-13.6500244,11.3900146-13.6500244,5.9699707,0,10.2099609,3.7000122,10.2099609,10.6000366v42.6499634h22.4000244v-44.1099854c0-21.3300171-12.1800537-29.4100342-25.9700317-29.4000244Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.402771,22.4813232c-7.8699951,0-16.3800049,6.1199951-24.6799927,12.4500122v-13.2700195h-30.4700317c14.1400146,4.7200317,24.9300537,17.2299805,24.9300537,36.039978,0,2.9299927-.2900391,6.2700195-.5599976,9.3400269H15.8427734c2.2200317,7.6599731,8.7700195,12.5499878,20.8900146,12.5499878,10.1799927,0,17.1499634-1.8200073,26.9099731-5.5800171v19.4500122h9.9800415l26.789978-36.5800171c5.6799927-7.8499756,11.4799805-15.1799927,11.4799805-23.3599854,0-7.2199707-4.3800049-11.039978-11.4899902-11.039978Z",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.0127563,38.8912964c-8.0799561,0-13.6599731,4.8699951-16.0299683,12.5499878h31.3499756c-.4099731-4.8800049-4.7399902-12.5499878-15.3200073-12.5499878Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app_logo.7e15797addec4fc099809b86a08d75a8.svg";
export { ForwardRef as ReactComponent };